/**
 * Rounds a numeric value to a specified precision.
 * @param value - The number to round
 * @param precision - The number of decimal places to round to (default: 2)
 * @returns The rounded number
 *
 * @example
 * ```ts
 * roundTo(123.456789, 2); // 123.46
 * roundTo(123.456789, 4); // 123.4568
 * roundTo(123, 2); // 123
 * ```
 */
export const roundTo = (value: number, precision = 2): number => {
  const factor = 10 ** precision;
  return Math.round(value * factor) / factor;
};
